import { render } from "./hs-textarea-material.vue?vue&type=template&id=54ae4bf0&scoped=true"
import script from "./hs-textarea-material.vue?vue&type=script&lang=js"
export * from "./hs-textarea-material.vue?vue&type=script&lang=js"

import "./hs-textarea-material.vue?vue&type=style&index=0&id=54ae4bf0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ae4bf0"]])

export default __exports__